<aside class="ph-products-nav" aria-label="Module Propero Assistant">
  <p class="ph-products-nav__title">{{ 'PRODUCTS.NAV_TITLE' | translate }}</p>
  <nav>
    <div
      *ngFor="let feature of features; trackBy: trackByFeatureId"
      class="ph-products-nav__item"
      [class.ph-products-nav__item--active]="activeId === feature.id">
      <ng-container *ngIf="mode === 'overview'; else detailLink">
        <a
          href="#{{ feature.id }}"
          class="ph-products-nav__link"
          [class.ph-products-nav__link--active]="activeId === feature.id"
          (click)="onOverviewSectionClick(feature.id, $event)">
          <i class="lni" [ngClass]="feature.icon" aria-hidden="true"></i>
          <span>{{ feature.titleKey | translate }}</span>
        </a>
        <a [routerLink]="['/products', feature.id]" class="ph-products-nav__more">
          {{ 'PRODUCTS.MORE_LINK' | translate }}
          <i class="lni lni-arrow-right" aria-hidden="true"></i>
        </a>
      </ng-container>
      <ng-template #detailLink>
        <a
          [routerLink]="['/products', feature.id]"
          class="ph-products-nav__link"
          [class.ph-products-nav__link--active]="activeId === feature.id"
          routerLinkActive="ph-products-nav__link--active"
          [routerLinkActiveOptions]="{ exact: true }">
          <i class="lni" [ngClass]="feature.icon" aria-hidden="true"></i>
          <span>{{ feature.titleKey | translate }}</span>
        </a>
      </ng-template>
    </div>
  </nav>
  <a *ngIf="mode === 'detail'" routerLink="/products" class="ph-products-nav__overview">
    {{ 'PRODUCTS.BACK_OVERVIEW' | translate }}
  </a>
</aside>
